/* =========================================================================
   COORIE — front-end behaviour (single namespaced module, no globals leak)
   ========================================================================= */
(function () {
  'use strict';

  if (window.__coorieBooted) { return; }
  window.__coorieBooted = true;

  var CFG = window.CoorieConfig || {};
  var MONEY = CFG.moneyFormat || '${{amount}}';
  var CART_URL = CFG.cartUrl || '/cart';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY
      .replace(/\{\{\s*amount\s*\}\}/g, intp + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, intp)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, intp + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intp);
  }

  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }

  function compareCents(it) {
    var c = it.compare_at_price;
    if ((!c || c <= it.price) && window.CoorieCompare) {
      c = window.CoorieCompare[it.variant_id] || window.CoorieCompare[it.id] || window.CoorieCompare[String(it.variant_id)] || 0;
    }
    return c && c > it.price ? c : 0;
  }

  /* Regalo del pack: linea hija de un pack que el descuento automatico deja a 0.
     Tambien reconoce los regalos antiguos a 0 EUR con precio de comparacion. */
  function isGift(it) {
    var p = it.properties || {};
    if (p._bundle_role !== 'child' || it.final_line_price !== 0) return false;
    return (it.original_line_price || 0) > 0 || compareCents(it) > 0;
  }

  var Cart = {
    drawer: null,
    _cart: null,
    init: function () {
      this.drawer = $('[data-coorie-cart-drawer]');
      var self = this;
      $all('[data-coorie-cart-open]').forEach(function (b) {
        b.setAttribute('data-bound', '1');
        on(b, 'click', function (e) { e.preventDefault(); self.open(); });
      });
      if (this.drawer) {
        $all('[data-coorie-cart-close]', this.drawer).forEach(function (b) {
          on(b, 'click', function () { self.close(); });
        });
        on(document, 'keydown', function (e) { if (e.key === 'Escape') self.close(); });
        this.bindItemEvents();
      }
      this.refresh();
    },
    open: function () { if (this.drawer) { this.drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; this.refresh(); } },
    close: function () { if (this.drawer) { this.drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; } },
    bindItemEvents: function () {
      var self = this;
      on(this.drawer, 'click', function (e) {
        var stepBtn = e.target.closest('[data-coorie-step]');
        var rmBtn = e.target.closest('[data-coorie-remove]');
        if (stepBtn) {
          var line = parseInt(stepBtn.getAttribute('data-line'), 10);
          var delta = parseInt(stepBtn.getAttribute('data-coorie-step'), 10);
          var current = parseInt(stepBtn.getAttribute('data-qty'), 10);
          self.changeLine(line, Math.max(0, current + delta));
        } else if (rmBtn) {
          self.changeLine(parseInt(rmBtn.getAttribute('data-line'), 10), 0);
        }
      });
    },
    lineItem: function (line) {
      return (this._cart && this._cart.items) ? this._cart.items[line - 1] : null;
    },
    changeLine: function (line, qty) {
      var self = this;
      if (qty <= 0) {
        var it = this.lineItem(line);
        if (it && it.properties && it.properties._bundle_role === 'main' && it.properties._bundle_id) {
          return this.removeBundleGroup(it.properties._bundle_id);
        }
        if (it && it.properties && it.properties._bundle_role === 'child' && it.properties._bundle_id && !isGift(it)) {
          return this.removeBundleGroup(it.properties._bundle_id, it.key);
        }
      }
      this.setBusy(true);
      fetch(CART_URL + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.setBusy(false); self.updateCount(cart.item_count); emit('coorie:cart:updated', cart); })
        .catch(function () { self.setBusy(false); });
    },
    removeBundleGroup: function (groupId, onlyKey) {
      var self = this;
      this.setBusy(true);
      var updates = {};
      var items = (this._cart && this._cart.items) ? this._cart.items : [];
      items.forEach(function (it) {
        if (!it.properties || it.properties._bundle_id !== groupId) return;
        /* Sin onlyKey se quita el pack entero; con onlyKey, esa linea y los regalos del pack. */
        if (!onlyKey || it.key === onlyKey || isGift(it)) { updates[it.key] = 0; }
      });
      if (!Object.keys(updates).length) { this.setBusy(false); return Promise.resolve(); }
      return fetch(CART_URL + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.setBusy(false); self.updateCount(cart.item_count); emit('coorie:cart:updated', cart); })
        .catch(function () { self.setBusy(false); });
    },
    addItems: function (items) {
      var self = this;
      return fetch(CART_URL + '/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { return self.refresh(); })
        .then(function () { self.open(); });
    },
    addId: function (variantId, quantity, properties) {
      var item = { id: variantId, quantity: quantity || 1 };
      if (properties) item.properties = properties;
      return this.addItems([item]);
    },
    refresh: function () {
      var self = this;
      return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.updateCount(cart.item_count); emit('coorie:cart:updated', cart); return cart; })
        .catch(function () {});
    },
    updateCount: function (count) {
      $all('[data-coorie-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.toggleAttribute('hidden', count < 1);
      });
    },
    setBusy: function (b) { if (this.drawer) this.drawer.classList.toggle('is-busy', b); },
    render: function (cart) {
      this._cart = cart;
      if (!this.drawer) return;
      this.syncTimer(cart);
      var list = $('[data-coorie-cart-items]', this.drawer);
      var empty = $('[data-coorie-cart-empty]', this.drawer);
      var summary = $('[data-coorie-cart-summary]', this.drawer);
      var countEl = $('[data-coorie-cart-itemcount]', this.drawer);
      if (countEl) countEl.textContent = cart.item_count;
      if (!list) return;

      if (cart.item_count === 0) {
        list.innerHTML = '';
        if (empty) empty.hidden = false;
        if (summary) summary.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      if (summary) summary.hidden = false;

      var savings = 0;
      var html = cart.items.map(function (it, i) {
        var line = i + 1;
        var orig = it.original_line_price || 0;
        var now = it.final_line_price;
        var cmp = compareCents(it);
        var was = Math.max(cmp ? cmp * it.quantity : 0, orig);
        var lineSave = was > now ? was - now : 0;
        savings += lineSave;
        var gift = isGift(it);
        var variant = (it.options_with_values || []).map(function (o) { return o.name + ': ' + o.value; }).filter(function (s) { return s.indexOf('Default Title') === -1 && s.indexOf('Title: ') !== 0; }).join(' · ');
        var props = '';
        var packTag = '';
        if (it.properties) {
          for (var k in it.properties) {
            if (Object.prototype.hasOwnProperty.call(it.properties, k) && k.charAt(0) !== '_' && it.properties[k]) {
              if (k === 'Pack') { packTag = '<div class="coorie-cart__packtag"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg><span>' + it.properties[k] + '</span></div>'; }
              else { props += '<div class="coorie-cart__prop">' + k + ': <b>' + it.properties[k] + '</b></div>'; }
            }
          }
        }
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') + '" alt="" loading="lazy" width="84" height="84">'
          : '';
        return '' +
          '<div class="coorie-cart__item">' +
            '<div class="coorie-cart__thumb">' + img + '</div>' +
            '<div class="coorie-cart__body">' +
              '<div class="coorie-cart__top">' +
                '<div class="coorie-cart__name">' + it.product_title + '</div>' +
                (gift ? '' :
                '<button class="coorie-cart__rm" data-coorie-remove data-line="' + line + '" aria-label="Quitar">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a9183" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>' +
                '</button>') +
              '</div>' +
              (variant ? '<div class="coorie-cart__prop">' + variant + '</div>' : '') +
              props +
              '<div class="coorie-cart__row">' +
                (gift
                  ? '<div class="coorie-cart__giftpill">Regalo incluido</div>'
                  : '<div class="coorie-cart__stepper">' +
                      '<button data-coorie-step="-1" data-line="' + line + '" data-qty="' + it.quantity + '" aria-label="Restar uno">−</button>' +
                      '<span>' + it.quantity + '</span>' +
                      '<button data-coorie-step="1" data-line="' + line + '" data-qty="' + it.quantity + '" aria-label="Sumar uno">+</button>' +
                    '</div>') +
                '<div class="coorie-cart__prices">' +
                  (was > now ? '<div class="coorie-cart__was">' + formatMoney(was) + '</div>' : '') +
                  (gift
                    ? '<div class="coorie-cart__now coorie-cart__now--free">GRATIS</div>'
                    : '<div class="coorie-cart__now">' + formatMoney(now) + '</div>') +
                  (!gift && lineSave > 0 ? '<div class="coorie-cart__save">(Ahorra ' + formatMoney(lineSave) + ')</div>' : '') +
                '</div>' +
              '</div>' +
              packTag +
            '</div>' +
          '</div>';
      }).join('');
      list.innerHTML = html;

      var savEl = $('[data-coorie-cart-savings]', this.drawer);
      var savRow = $('[data-coorie-cart-savings-row]', this.drawer);
      if (savEl) savEl.textContent = '-' + formatMoney(savings);
      if (savRow) savRow.hidden = savings <= 0;
      $all('[data-coorie-cart-subtotal]', this.drawer).forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    },
    /* El temporizador solo existe mientras haya algo en el carrito.
       Con el carrito vacio se oculta, se para y se borra la marca guardada;
       la cuenta arranca en el momento en que se anade el primer producto. */
    syncTimer: function (cart) {
      if (!this.drawer) return;
      var el = $('[data-coorie-timer]', this.drawer);
      if (!el) return;
      var row = $('[data-coorie-timer-row]', this.drawer) || el.parentElement;
      var KEY = 'coorie_cart_timer_start';
      var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;

      if (count < 1) {
        if (Cart._timer) { clearInterval(Cart._timer); Cart._timer = null; }
        try { localStorage.removeItem(KEY); } catch (e) {}
        if (row) row.hidden = true;
        return;
      }

      if (row) row.hidden = false;
      if (Cart._timer) return;

      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 5;
      var TOTAL = mins * 60;
      var start = parseInt(localStorage.getItem(KEY), 10);
      function persist(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} }
      if (!start || isNaN(start) || start > Date.now()) { start = Date.now(); persist(start); }
      function tick() {
        var elapsed = Math.floor((Date.now() - start) / 1000);
        // Al llegar a 00:00 el temporizador se reinicia automaticamente.
        // Se muestra 00:00 durante un segundo y vuelve a empezar.
        if (elapsed > TOTAL) {
          var cycles = Math.floor(elapsed / TOTAL);
          start = start + cycles * TOTAL * 1000;
          persist(start);
          elapsed = Math.floor((Date.now() - start) / 1000);
        }
        var left = Math.max(0, TOTAL - elapsed);
        var m = String(Math.floor(left / 60)).padStart(2, '0');
        var s = String(left % 60).padStart(2, '0');
        el.textContent = m + ':' + s;
      }
      Cart._timer = setInterval(tick, 1000); tick();
    }
  };

  function initMenu() {
    var drawer = $('[data-coorie-menu]');
    if (!drawer) return;
    function setOpen(o) { drawer.classList.toggle('is-open', o); document.documentElement.style.overflow = o ? 'hidden' : ''; }
    $all('[data-coorie-menu-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); setOpen(true); }); });
    $all('[data-coorie-menu-close]', drawer).forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
  }

  function initGallery(scope) {
    $all('[data-coorie-gallery]', scope).forEach(function (g) {
      var main = $('[data-coorie-gallery-main]', g);
      var thumbs = $all('[data-coorie-thumb]', g);
      thumbs.forEach(function (t) {
        on(t, 'click', function () {
          var src = t.getAttribute('data-src');
          var alt = t.getAttribute('data-alt') || '';
          if (main && src) { main.src = src; main.alt = alt; }
          thumbs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-current', 'false'); });
          t.classList.add('is-active'); t.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initAccordions(scope) {
    $all('[data-coorie-accordion]', scope).forEach(function (acc) {
      var btn = $('[data-coorie-acc-trigger]', acc);
      var panel = $('[data-coorie-acc-panel]', acc);
      if (!btn || !panel) return;
      on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  function initBundles(scope) {
    var form = $('[data-coorie-product-form]', scope);
    if (!form) return;
    var qtyInput = $('[data-coorie-qty-input]', form);
    var ctaPrice = $('[data-coorie-cta-price]', form);
    var options = $all('[data-coorie-bundle]', form);

    function select(opt) {
      options.forEach(function (o) {
        var on_ = o === opt;
        o.classList.toggle('is-active', on_);
        var radio = $('[data-coorie-bundle-radio]', o);
        if (radio) radio.checked = on_;
        var plugs = $('[data-coorie-plugs]', o);
        if (plugs) plugs.hidden = !on_;
        $all('select', o).forEach(function (s) { if (s.closest('[data-coorie-plugs]')) s.disabled = !on_; });
      });
      var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
      if (qtyInput) qtyInput.value = qty;
      var exInput = $('[data-coorie-extras-input]', form);
      if (exInput) { exInput.value = opt.getAttribute('data-extra-ids') || ''; }
      if (ctaPrice) {
        var pric = opt.getAttribute('data-total-price');
        if (pric) ctaPrice.textContent = pric;
      }
    }
    options.forEach(function (opt) {
      on(opt, 'click', function (e) {
        if (e.target.closest('[data-coorie-plugs]')) return;
        select(opt);
      });
      var radio = $('[data-coorie-bundle-radio]', opt);
      on(radio, 'change', function () { select(opt); });
    });
    var pre = options.filter(function (o) { return o.getAttribute('data-default') === 'true'; })[0] || options[0];
    if (pre) select(pre);
  }

  function initProductForm(scope) {
    var form = $('[data-coorie-product-form]', scope);
    if (!form || form.getAttribute('data-bound') === '1') return;
    form.setAttribute('data-bound', '1');
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = $('[data-coorie-atc]', form);
      var variantId = (form.querySelector('[name="id"]') || {}).value;
      if (!variantId) return;
      var qty = parseInt((form.querySelector('[data-coorie-qty-input]') || {}).value, 10) || 1;
      var packName = (form.querySelector('[data-coorie-pack-input]') || {}).value || '';
      var properties = {};
      $all('[data-coorie-prop]', form).forEach(function (sel) {
        if (!sel.disabled && sel.value) properties[sel.getAttribute('data-coorie-prop')] = sel.value;
      });
      if (packName) properties['Pack'] = packName;

      var exInput = form.querySelector('[data-coorie-extras-input]');
      var extraIds = (exInput && exInput.value ? exInput.value : '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

      var activeBundle = form.querySelector('[data-coorie-bundle].is-active') || form.querySelector('[data-coorie-bundle]');
      var linkRemoval = extraIds.length > 0 && !(activeBundle && activeBundle.getAttribute('data-link-removal') === 'false');
      var groupId = linkRemoval ? ('bnd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7)) : '';

      var item = { id: variantId, quantity: qty };
      if (linkRemoval) { properties['_bundle_id'] = groupId; properties['_bundle_role'] = 'main'; }
      if (Object.keys(properties).length) item.properties = properties;
      var items = [item];

      extraIds.forEach(function (id) {
        var ex = { id: id, quantity: 1 };
        var exProps = {};
        if (packName) exProps['Pack'] = packName;
        if (linkRemoval) { exProps['_bundle_id'] = groupId; exProps['_bundle_role'] = 'child'; }
        if (Object.keys(exProps).length) ex.properties = exProps;
        items.push(ex);
      });

      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      Cart.addItems(items)
        .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } })
        .catch(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
    });
  }

  function initAddButtons(scope) {
    $all('[data-coorie-add]', scope).forEach(function (b) {
      if (b.getAttribute('data-bound') === '1') return;
      b.setAttribute('data-bound', '1');
      on(b, 'click', function (e) {
        e.preventDefault();
        var id = b.getAttribute('data-coorie-add');
        if (!id) return;
        b.classList.add('is-loading');
        Cart.addId(id, parseInt(b.getAttribute('data-qty'), 10) || 1)
          .then(function () { b.classList.remove('is-loading'); });
      });
    });
  }

  function initStickySubmit(scope) {
    $all('[data-coorie-sticky-submit]', scope || document).forEach(function (b) {
      if (b.getAttribute('data-bound') === '1') return;
      b.setAttribute('data-bound', '1');
      on(b, 'click', function (e) {
        e.preventDefault();
        var form = $('[data-coorie-product-form]');
        if (form) {
          if (form.requestSubmit) { form.requestSubmit(); }
          else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        } else { Cart.open(); }
      });
    });
  }

  function initStickyMirror() {
    var mainNow = $('[data-coorie-price-now]');
    var skNow = $('[data-coorie-sticky-price-now]');
    if (!mainNow || !skNow) return;
    var mainWas = $('[data-coorie-price-was]');
    var skWas = $('[data-coorie-sticky-price-was]');
    function copy() {
      skNow.textContent = mainNow.textContent;
      if (skWas) {
        var show = mainWas && !mainWas.hidden && (mainWas.textContent || '').trim();
        if (show) { skWas.textContent = mainWas.textContent; skWas.hidden = false; }
        else { skWas.hidden = true; }
      }
    }
    copy();
    window.setTimeout(copy, 60);
    if (window.MutationObserver) {
      var mo = new MutationObserver(copy);
      mo.observe(mainNow, { childList: true, characterData: true, subtree: true });
      if (mainWas) mo.observe(mainWas, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
  }

  function initSticky(scope) {
    var bar = $('[data-coorie-sticky]');
    var anchor = $('[data-coorie-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-visible', en.boundingClientRect.bottom < 0);
      });
    }, { threshold: 0, rootMargin: '0px' });
    io.observe(anchor);
  }

  function initAll(scope) {
    scope = scope || document;
    initGallery(scope);
    initAccordions(scope);
    initBundles(scope);
    initProductForm(scope);
    initAddButtons(scope);
    initStickySubmit(scope);
  }

  function boot() {
    initMenu();
    Cart.init();
    initAll(document);
    initSticky(document);
    initStickyMirror();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initMenu();
    Cart.init();
    initSticky(document);
    initStickyMirror();
  });

  window.Coorie = { Cart: Cart, refresh: function () { return Cart.refresh(); } };
})();